import { Button, typographyStyle, Colors, Flex } from '@revenuemarket/cds';
import { CloseX } from '@revenuemarket/ui';
import { ModalProps, Typography } from 'antd';

import CommonModal from './CommonModal';

interface Props extends ModalProps {
  onOk: () => void;
}

const AnalysisEditConfirmModal: React.FC<Props> = ({ ...props }) => {
  return (
    <CommonModal
      width={320}
      footer={null}
      closable={false}
      title={
        <Flex align="center" justify="space-between">
          <Typography.Text
            style={{
              ...typographyStyle['16_600'],
              color: Colors.gray800,
            }}
          >
            변경사항을 저장하지 않고 나갈까요?
          </Typography.Text>
          <Button
            onClick={props.onCancel}
            border
            buttonType="weak"
            icon={<CloseX width={18} height={18} />}
          />
        </Flex>
      }
      {...props}
    >
      <Flex
        direction="column"
        gap={35}
        style={{
          marginTop: 16,
        }}
      >
        <Flex justify="flex-end" gap={4}>
          <Button border buttonType="weak" buttonSize="large" onClick={props.onCancel}>
            닫기
          </Button>
          <Button buttonType="primary" buttonSize="large" onClick={props.onOk}>
            확인
          </Button>
        </Flex>
      </Flex>
    </CommonModal>
  );
};

export default AnalysisEditConfirmModal;
